export const DisplayAvatar = ({ url, name = "" }) => {
 
  return (
    <div className={`userProfile ${url ? "" : "noAvatar"}`}>
      {url ? (
        <img src={url} referrerPolicy="no-referrer" alt="User Name" />
      ) : (
        <span className="initials">
          {name
            ?.split(" ")
            ?.slice(0, 2)
            ?.map((word) => word[0])
            ?.join("")
            ?.toUpperCase()}
        </span>
      )}
    </div>
  );
};
